/**
 * 환경설정 페이지 (발주개수차수·소유자권한·예약알람·접수알림·수주반경·진동)
 * 레거시 _sky__m_menu_setting_08_01.php (= _sky__m_menu_setting_08.php?ontab=1) 대체
 *
 * Blade 는 정적 스켈레톤만 제공하고, 권한/플래그 기반의 행 노출·셀렉트 옵션·예약알람 아이콘 등
 * 모든 분기/리스트 렌더는 이 모듈의 initialize()→_renderInitialState() 가 cfg(blade #page-data)
 * 를 읽어 수행한다.
 */
import Util from '../../Common/Util';
const ON  = '/img/m/opt_onoffbtn_on_rnw.svg';
const OFF = '/img/m/opt_onoffbtn_off_rnw.svg';
/** 토글 이미지 + 옆 상태 글자 — 회색 토글만으로는 비활성처럼 보여서 글자를 같이 둔다. labels = [켜짐 글, 꺼짐 글] */
function setToggle(id, on, labels = ['켜짐', '꺼짐']) {
    $('#' + id).attr('src', on ? ON : OFF);
    $(`.env-tg-state[data-for="${id}"]`).text(on ? labels[0] : labels[1]).toggleClass('is-on', on);
}
const ALARM_TS = ['ⓧ', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮'];

export default class SettingEnv {
    constructor() {
        const c = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        this.cfg = c;
        this.memOrderCounter = parseInt(c.memOrderCounter, 10) || 0;
        this.memOrderCnt = parseInt(c.memOrderCnt, 10) || 0; // 보유 발주개수(my_able_Cnt)
        this.isVibrate = parseInt(c.isVibrate, 10) || 0;
        // 작업사진 자동 찾기 — 기본 꺼짐. agreed 는 첫 사용 동의 결과(null 미정 / 1 동의 / 0 거부)
        this.autoFind = parseInt(c.autoFindPhotos, 10) || 0;
        this.autoFindAgreed = (c.autoFindAgreed == null) ? null : parseInt(c.autoFindAgreed, 10);
        this.workSlot = 0; // 예약알람 편집 중인 슬롯(1~3)
        // 광고·혜택 알림 — 매체별 agree|refuse|none (소유자만, 아니면 null → 카드 없음)
        this.adConsent = (c.adConsent && typeof c.adConsent === 'object') ? Object.assign({}, c.adConsent) : null;
        // 사진 활용 동의(MARKETING) — agree|refuse|none. 소유자만(아니면 null → 구역 없음)
        this.photoConsent = c.photoConsent || null;
    }

    initialize() {
        this._renderInitialState();
        this._bindEvents();
    }

    // cfg 기반 초기 상태/리스트 렌더 (구 Blade @unless/@if/@foreach 대체)
    _renderInitialState() {
        const c = this.cfg;

        // ── 발주개수 / 차수 (수발주자만 노출) ────────────
        if (!c.isBaljooja) {
            $('#env-row-ordercnt').show();
            $('#env-ordercnt-text').text((c.memOrderCnt || 0) + '개');

            $('#env-row-chrsoo').show();
            if (c.msixNday) {
                $('#env-msix-badge')
                    .html('-6차 <font class="env-blue">(' + c.msixNday + '일차)</font>')
                    .show();
            } else {
                const $sel = $('#orderrecive_level').show();
                if (!c.canChrsoo) $sel.prop('disabled', true);
                // value="0" 옵션이 두 개 — .val('0') 은 첫 옵션을 선택(레거시와 동일)
                $sel.val(String(this.memOrderCounter));
            }
        }

        // ── 소유자권한 (소속자가 있을 때만 노출, 옵션 동적 생성) ────────────
        if (Array.isArray(c.driverList) && c.driverList.length > 0) {
            const $permit = $('#permitset');
            c.driverList.forEach((d) => {
                const label = d.name + (d.granted ? ' 에게 권한 부여 중' : ' 에게 소유자 권한주기');
                $('<option>').attr('value', d.num)
                    .attr('data-name', d.name)
                    .attr('data-granted', d.granted ? 1 : 0)
                    .text(label)
                    .appendTo($permit);
            });
            $('#env-row-permit').show();
        }

        // ── 예약알람 슬롯 3개 표시 ────────────
        const icons = c.alarmIcons || [];
        const ra = c.reservAlarm || [0, 0, 0];
        for (let i = 1; i <= 3; i++) {
            const ic = icons[ra[i - 1]] || 'ⓧ';
            $('#rservAset' + i).html('<font style="font-size:25px;font-weight:bolder">' + ic + '</font>');
        }

        // ── 예약알람 시간 아이콘 1..15 + 0(無) ────────────
        const $times = $('#env-alarm-times').empty();
        for (let x = 1; x < 16; x++) {
            const ic = icons[x] || ('' + x);
            $('<a href="javascript:void(0)" class="env-alarm-time" style="padding:5px">')
                .attr('data-n', x)
                .html('<font class="env-ink" style="font-size:30px;font-weight:bolder">' + ic + '</font>')
                .appendTo($times);
        }
        $('<a href="javascript:void(0)" class="env-alarm-time" style="padding:5px">')
            .attr('data-n', 0)
            .html('<font class="env-ink" style="font-size:30px;font-weight:bolder">無</font>')
            .appendTo($times);

        // ── 접수알림 / 수주반경 (수발주자만, 소유자 아니면 disabled) ────────────
        if (!c.isBaljooja) {
            $('#env-row-recv').show();
            $('#order_reciveset').val(String(c.recvOrder));
            if (c.memPermit !== '소유자') $('#order_reciveset').prop('disabled', true);

            $('#env-row-areakm').show();
            const $km = $('#my_reciveKM');
            // 레거시 첫 옵션: 0 KM (수주불가) — kmList 와 별도 라벨이라 하드코딩
            $('<option>').val(0).text('0 KM (수주불가)').appendTo($km);
            (c.kmList || []).forEach((km) => {
                $('<option>').val(km).text(km + ' KM').appendTo($km);
            });
            $km.val(String(c.areaKm));
            if (c.memPermit !== '소유자') $km.prop('disabled', true);
        }

        // ── 진동: is_vibrate==0 → ON 이미지(레거시 반전) ────────────
        setToggle('is_vibrate', this.isVibrate === 0);

        // ── 광고·혜택 알림: 매체별 agree → ON ──────────────────────
        this._renderAdConsent();
        this._renderPhotoConsent();

        // ── 작업사진 자동 찾기: 1 → ON (반전 없음) ──────────────────
        // 격자 피커를 못 하는 앱(구앱·PC)에서는 줄째로 감춘다 — 켜도 일지에서 아무 일이 없어
        // "켰는데 왜 안 되냐"는 문의만 생긴다. 판정은 getCapabilities.picker(자동 찾기는 listPhotos{since,until} 의 옵션).
        if ($j.F.App.pickerSupported()) {
            setToggle('auto_find_photos', this.autoFind === 1);
        } else {
            $('#auto_find_photos').closest('tr').hide();
        }

        // ── 화면모드/글자크기 ────────────────────────────────────────
        // 셀렉트는 '유저가 고른 값'(getPref: light|dark|auto)을 보여준다.
        if ($('#env-theme').length) {
            $('#env-theme').val($j.F.Mobile.Theme.getPref());
            $('#env-fontsize').val($j.F.Mobile.Theme.getFontSizePref());
        }
    }

    _bindEvents() {
        // 앱 업데이트 — 신앱은 네이티브가 스토어를 연다. 구앱은 브로커 자체가 없어 false 를
        // 반환하므로 등록된 스토어 주소로 직접 이동한다. 업데이트가 필요한 쪽이 곧 구앱이라
        // 이 폴백이 실질 경로다. (주소는 /adm/config 「앱 버전 · 스토어」 에서 앱별로 등록)
        $('#env-app-update').on('click', function () {
            if ($j.F.App.openPlaystore()) return;
            const url = $(this).data('store');
            if (url) location.href = url;
        });

        const self = this;
        // 도움말 모달 (Point 패턴: backdrop + modal, .help-close / 배경 클릭으로 닫기)
        const openHelp  = () => { $('#help-backdrop').show(); $('#help-modal').css('display', 'flex'); };
        const closeHelp = () => { $('#help-backdrop').hide(); $('#help-modal').hide(); };
        $('#env-help-open').on('click', openHelp);
        $('#help-modal').on('click', '.help-close', closeHelp);
        $('#help-backdrop').on('click', closeHelp);

        // 발주개수차수
        $('#orderrecive_level').on('change', () => self.onChrsooChange());

        // 진동켜기
        $('#is_vibrate').on('click', () => self.toggleVibrate());

        // 작업사진 자동 찾기
        $('#auto_find_photos').on('click', () => self.toggleAutoFind());

        // 알림·동의 설정 카드 — 제목줄로 접고 펴기 · 체크 행(구역별 「전체」 포함) · 동의 내용
        $('#env-consent-hd').on('click', () => self.toggleConsentFold());
        $('#env-consent-card')
            .on('click', '.js-ad-ck', function () { self.toggleAdConsent($(this).data('ch')); })
            .on('click', '.js-ad-all', () => self.toggleAdAll())
            .on('click', '.js-photo-toggle', () => self.togglePhotoConsent());
        $('#env-ad-term').on('click', () => self.openAdTerm());
        $('#env-photo-term').on('click', () => self.openPhotoTerm());

        // 화면모드(라이트/다크/자동)·글자크기 — 저장은 계정(app_config DB), 적용은 즉시
        $('#env-theme').on('change', function () { $j.F.Mobile.Theme.setTheme(this.value); });
        $('#env-fontsize').on('change', function () { $j.F.Mobile.Theme.setFontSize(this.value); });

        // 접수알림 / 수주반경
        $('#order_reciveset').on('change', function () { self._save('myset_reciveorder', this.value); });
        $('#my_reciveKM').on('change', function () { self._save('mem_areakm', this.value); });

        // 소유자권한 (다중 부여 — 옵션 선택 시 그 행만 토글)
        $('#permitset').on('change', function () { self.onPermitChange(this); });

        // 예약알람
        $('.env-alarm-slot').on('click', function () { self.openAlarm(parseInt($(this).data('slot'), 10), true); });
        $('.env-alarm-pick').on('click', function () { self.openAlarm(parseInt($(this).data('slot'), 10), false); });
        $('#env-alarm-close, #env-alarm-ok').on('click', () => $('#reserTimeSet').hide());
        // env-alarm-time 은 init 시 동적 생성 → delegated binding
        $(document).on('click', '.env-alarm-time', function () {
            self.timeSetTo(parseInt($(this).data('n'), 10));
        });
    }

    // 레거시 go_save_fly 핵심(키-값 저장)
    _save(gokey, govalue) {
        $.ajax({
            type: 'POST', url: '/m/ajax/setting/save', data: { gokey, govalue },
            success: (data) => {
                if (gokey === 'mem_ordercounter') return; // 차수는 서버 처리만, UI 갱신 없음
                if (parseInt(String(data).trim(), 10) === 1 && gokey === 'is_vibrate') {
                    $j.F.App.syncSettings({ push: { vibrate: govalue } });
                }
            },
        });
    }

    // 레거시 checkOKchange — 발주개수 부족 검증 후 차수 저장
    onChrsooChange() {
        const el = document.getElementById('orderrecive_level');
        let tar = parseInt(el.value, 10);
        let cur = parseInt(this.memOrderCounter, 10);
        if (isNaN(cur)) cur = 0;
        if (cur > 0) cur = 0;
        if (isNaN(tar)) { Util.swalert('숫자가 아닙니다.'); return; }

        if (tar < 0) {
            const need = Math.abs(tar);
            if (need > this.memOrderCnt) {
                const html = "<font style='font-size:9pt;line-height:23px'>오더 순서를 낮추려면 그만큼의 <font style='color:red;font-weight:bold'>발주차수</font>가 필요합니다.\n"
                    + "현재 발주개수는 <font style='color:red;font-weight:bold'>[" + this.memOrderCnt + "]개</font> 이며\n"
                    + "오더 순서를 [" + need + "]로 설정하려면 <font style='color:red;font-weight:bold'>[" + need + "]개 발주가 필요합니다.</font></font>";
                $j.Ui.Dialog.open({ tone: 'warn', title: '발주 개수 부족', html, confirm: '확인' })
                    .then(() => { el.value = String(cur); });
                return;
            }
        }
        this._save('mem_ordercounter', el.value);
    }

    /** 알림·동의 설정 카드 — 접힌 채로 시작, 제목줄을 누르면 펼친다 */
    toggleConsentFold() {
        const $card = $('#env-consent-card');
        const open = $card.hasClass('is-fold');
        $card.toggleClass('is-fold', !open);
        $('#env-consent-body').prop('hidden', !open);
        $('#env-consent-hd').attr('aria-expanded', open ? 'true' : 'false');
    }

    /** 체크 행 모양 — aria-checked 로만 그린다 (CSS 가 본다) */
    _setCk($el, on) { $el.attr('aria-checked', on ? 'true' : 'false'); }

    _renderAdConsent() {
        if (!this.adConsent) return;
        const self = this;
        const chs = Object.keys(this.adConsent);
        $('#env-consent-card .js-ad-ck').each(function () { self._setCk($(this), self.adConsent[$(this).data('ch')] === 'agree'); });
        this._setCk($('#env-consent-card .js-ad-all'), chs.length > 0 && chs.every((k) => self.adConsent[k] === 'agree'));
    }

    /**
     * 광고·혜택 소식 체크 — 한 매체만 보내고(다른 매체는 건드리지 않음) 응답의 state 로 다시 그린다.
     * 이력에 남는 동의라 낙관 갱신을 하지 않는다 — 서버가 기록한 상태가 정본이다.
     */
    toggleAdConsent(ch) {
        if (!this.adConsent) return;
        this._saveAd({ [ch]: this.adConsent[ch] === 'agree' ? 0 : 1 });
    }

    /** 「전체」 — 셋 다 동의면 셋 다 끄고, 아니면 셋 다 켠다 (한 요청에 매체 셋) */
    toggleAdAll() {
        if (!this.adConsent) return;
        const chs = Object.keys(this.adConsent);
        const allOn = chs.every((k) => this.adConsent[k] === 'agree');
        const data = {};
        chs.forEach((k) => { data[k] = allOn ? 0 : 1; });
        this._saveAd(data);
    }

    _saveAd(data) {
        if (this._adBusy) return;
        this._adBusy = true;
        $.ajax({ type: 'POST', url: '/m/ajax/ad-consent', dataType: 'json', data })
            .done((res) => {
                if (!res || !res.result) { Util.swalert(res && res.message ? res.message : '저장하지 못했습니다.'); return; }
                this.adConsent = Object.assign({}, res.state);
                this._renderAdConsent();
                if (res.message) $j.Ui.Toast.show(res.message, { type: 'success', place: 'bottom', timeout: 4000 });
            })
            .fail(() => Util.swalert('네트워크 오류로 저장하지 못했습니다.'))
            .always(() => { this._adBusy = false; });
    }

    _renderPhotoConsent() {
        if (!this.photoConsent) return;
        setToggle('photo_consent', this.photoConsent === 'agree', ['동의함', '미동의']);
    }

    /**
     * 사진 활용 동의(MARKETING) — 일지 사진 피커와 같은 저장 경로(/m/ajax/marketing-consent).
     * 응답의 is_ad(2 동의 / 1 미동의)로 다시 그리고, 일지가 읽는 MEMBER.is_ad 도 맞춘다.
     */
    togglePhotoConsent() {
        if (!this.photoConsent || this._photoBusy) return;
        const agree = this.photoConsent === 'agree' ? 0 : 1;
        this._photoBusy = true;
        $.ajax({ type: 'POST', url: '/m/ajax/marketing-consent', dataType: 'json', data: { agree } })
            .done((res) => {
                if (!res || !res.result) { Util.swalert(res && res.message ? res.message : '저장하지 못했습니다.'); return; }
                this.photoConsent = parseInt(res.is_ad, 10) === 2 ? 'agree' : 'refuse';
                if (typeof MEMBER !== 'undefined' && MEMBER) MEMBER.is_ad = res.is_ad;
                this._renderPhotoConsent();
            })
            .fail(() => Util.swalert('네트워크 오류로 저장하지 못했습니다.'))
            .always(() => { this._photoBusy = false; });
    }

    /** 사진 활용 동의 전문 — 전환 시트와 같은 본문(/m/ajax/modal/term mkterm) */
    openPhotoTerm() {
        const modal = $j.Ui.Modal.open({ mode: 'full', panelClass: 'lc-doc-modal', title: '작업사진 활용 동의', html: '<div class="lc-doc">불러오는 중…</div>' });
        $.ajax({ url: '/m/ajax/modal/term', method: 'POST', data: { tag: 'mkterm' } })
            .done((html) => modal.setBody(`<div class="lc-doc">${html || '내용이 없습니다.'}</div>`))
            .fail(() => modal.setBody('<div class="lc-doc">내용을 불러오지 못했습니다.</div>'));
    }

    /** 동의 내용 전문 — 가입 화면과 같은 본문(/m/ajax/modal/term adterm) */
    openAdTerm() {
        const modal = $j.Ui.Modal.open({ mode: 'full', panelClass: 'lc-doc-modal', title: '광고성 정보 수신 동의', html: '<div class="lc-doc">불러오는 중…</div>' });
        $.ajax({ url: '/m/ajax/modal/term', method: 'POST', data: { tag: 'adterm' } })
            .done((html) => modal.setBody(`<div class="lc-doc">${html || '내용이 없습니다.'}</div>`))
            .fail(() => modal.setBody('<div class="lc-doc">내용을 불러오지 못했습니다.</div>'));
    }

    toggleVibrate() {
        this.isVibrate = this.isVibrate === 1 ? 0 : 1;
        // is_vibrate: 1=끄기 → off 이미지, 0=켜기 → on 이미지
        setToggle('is_vibrate', this.isVibrate === 0);
        this._save('is_vibrate', this.isVibrate);
    }

    /**
     * 작업사진 자동 찾기 — 끄기는 즉시, 켜기는 아직 동의 전이면 동의창을 거친다(거부했던 회원도 여기서 다시 켤 수 있다).
     * 동의창은 이 한 곳뿐이다 — 일지(DiaryJobs)는 설정이 켜져 있을 때만 찾고, 묻지 않는다(2026-10-23). 기본은 꺼짐.
     */
    toggleAutoFind() {
        if (this.autoFind === 1) { this._setAutoFind(0); return; }
        if (this.autoFindAgreed === 1) { this._setAutoFind(1); return; }

        const html = `
            <ul class="dj-find-consent">
                <li><b>이 작업 시간대(앞뒤 30분)</b>에 찍은 사진만 찾아 추천합니다.</li>
                <li>추천 사진은 직접 골라 올리고, 찾은 결과는 <b>폰 밖으로 나가지 않습니다.</b></li>
                <li>환경설정에서 <b>언제든 끌 수 있습니다.</b></li>
            </ul>`;
        $j.Ui.Dialog.open({
            tone:    'info',
            title:   '작업사진 자동 찾기',
            html,
            agree:   { label: '위 내용을 확인했습니다' },
            confirm: '사용하기',
            cancel:  '취소',
            dismissible: false,
        }).then(ok => {
            if (!ok) return;
            this.autoFindAgreed = 1;
            // 순서대로 저장 — 동시에 보내면 서버(updateMemberAppConfig)가 app_config 를 통째로 다시 써서 한 키가 사라진다
            $.post('/m/ajax/setting/save', { gokey: 'auto_find_photos_agreed', govalue: 1 })
                .always(() => this._setAutoFind(1));
        });
    }

    _setAutoFind(v) {
        this.autoFind = v;
        setToggle('auto_find_photos', v === 1);
        this._save('auto_find_photos', v);
        if (typeof MEMBER !== 'undefined' && MEMBER && MEMBER.app_config) MEMBER.app_config.auto_find_photos = v;   // 사이트 부트가 세운 MEMBER (#site-boot)
    }

    // select 에서 한 명 선택 → 그 옵션만 토글(다중 부여). 다른 옵션은 건드리지 않음.
    onPermitChange(sel) {
        const $sel = $(sel);
        const $opt = $sel.find('option:selected');
        const num  = parseInt($opt.attr('value'), 10);
        if (isNaN(num) || num < 1) { $sel.val(''); return; } // 기본 옵션 선택 시 무시

        const cur  = parseInt($opt.attr('data-granted'), 10) || 0;
        const next = cur === 1 ? 0 : 1;
        const name = $opt.attr('data-name') || '';

        // 확인 다이얼로그 도중/이후에도 placeholder 로 보이게 즉시 리셋
        $sel.val('');

        const msg = next === 1
            ? name + ' 기사에게 소유자 권한을 부여할까요?'
            : name + ' 기사의 소유자 권한을 해제할까요?';

        Util.swalert([msg, 'question'], () => {
            $.ajax({
                type: 'POST', url: '/m/ajax/setting/driver-permit',
                data: { drivernumber: num, grant: next },
                success: (data) => {
                    if (data && data.result) {
                        // 그 옵션의 상태/라벨만 in-place 갱신(reload 없음)
                        $opt.attr('data-granted', next);
                        $opt.text(name + (next === 1 ? ' 에게 권한 부여 중' : ' 에게 소유자 권한주기'));
                    } else {
                        alert((data && data.message) ? data.message : '권한 설정에 실패했습니다');
                    }
                },
            });
        }, ['확인', '아니오']);
    }

    // 예약알람 슬롯 선택 (show=true 면 시간선택 패널 표시)
    openAlarm(slot, show) {
        if (!slot || slot < 1 || slot > 3) return;
        // 색은 인라인이 아니라 .on 클래스로 — 인라인 hex 는 다크모드에서 덮을 수 없다
        $('#eatimeSetDiv1, #eatimeSetDiv2, #eatimeSetDiv3').removeClass('on');
        $('#eatimeSetDiv' + slot).addClass('on');
        this.workSlot = slot;
        if (show) $('#reserTimeSet').show();
    }

    timeSetTo(n) {
        if (this.workSlot < 1 || this.workSlot > 3) return;
        const nn = ALARM_TS[n] || 'ⓧ';
        $('#rservAset' + this.workSlot).html("<font class='env-ink' style='font-size:25px;font-weight:bolder'>" + nn + '</font>');
        $.ajax({
            type: 'POST', url: '/m/ajax/setting/reserv-alarm',
            data: { whichOne: 'aset_' + this.workSlot, whichvalue: n },
        });
    }
}
